export default __webpack_public_path__ + "static/media/WRB_DIAGRAM_XLG.af554bde.png";